export const fetchStates = {
    start: {meta: {loaded: false, fetching: true, error: false}},
    success: {meta: {loaded: true, fetching: false, error: false}},
    failure: {meta: {loaded: false, fetching: false, error: true}}
};

export const submitStates = {
    start: {meta: {submitting: true}},
    success: {meta: {submitting: false}},
    failure: {meta: {submitting: false}}
};


// WEBPACK FOOTER //
// ./src/constants/actionMetaStates.js